<template>
  <div class="yo-content-block" v-if="question.ansType === 'unknown'">
    <h2>Choose Answer Type</h2>

    <el-button :key="qt.name" v-for="qt in QS.ansTypes" style="margin: 4px;" :style="qt.style" @click="setAnsType(qt.type)">{{ qt.name }}</el-button>
  </div>
</template>

<script>
import * as QS from '../yoqb-compos/question.js'
export default {
  props: {
    question: {}
  },
  data () {
    return {
      QS
    }
  },
  methods: {
    setAnsType (type) {
      // this.question.ansType = v
      QS.injectAnsDataByType(this.question, type)
      this.$forceUpdate()
    }
  }
}
</script>

<style>

</style>
"